import { DashboardModuleLayoutWidget, DashboardModuleLayoutWidgetSubType, DashboardModuleLayoutWidgetWidgetLink } from '@/modules/dashboard-module/shared/models/dashboard-module.model'
import { DashboardModuleSharedWidgetsNewCaseWidgetState, initialDashboardModuleSharedWidgetsNewCaseWidgetState } from '@/modules/dashboard-module/shared/widgets/new-case-widget/dashboard-module-shared-widgets-new-case-widget.model'
import { store } from '@/store/store'
import { Vue, Prop, Component, Ref } from 'vue-property-decorator'
import { IDENTIFIER_SCOPES } from '@/api/resources/identifierScopesResource'
import { PATIENT_IDENTIFIER_CODES } from '@/api/resources/IdentifierRegexesService'
import { PromiseUtils } from '@/shared/util/promise-utils'
import ModalRepeatedPatients from '@/modules/RegistryModule/views/editCase/modals/ModalRepeatedPatients.vue'
import { patientService } from '@/api/services/patient/patient/patient.service'
import { PatientSearchResponse } from '@/api/services/patient/patient/patient.dto'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { StrictNullable } from '@/shared/types/app.types'
import { IdentifierRegexResponse } from '@/api/resources/common/initialization/common-initialization.dto'

@Component({
    components: {
        ModalRepeatedPatients
    }
})
export default class DashboardModuleSharedWidgetsNewCaseWidget extends Vue {
    @Prop() readonly widgetData!: DashboardModuleLayoutWidget

    @Ref('modalRepeatedPatients') modalRepeatedPatients!: any

    state: DashboardModuleSharedWidgetsNewCaseWidgetState
    constructor() {
        super()
        this.state = initialDashboardModuleSharedWidgetsNewCaseWidgetState()
    }

    get regex(): IdentifierRegexResponse[] {
        return store.getters.regex
    }

    get isCaseSubtype(): boolean {
        return this.widgetData.subType === DashboardModuleLayoutWidgetSubType.CASE
    }

    get isRequestSubtype(): boolean {
        return this.widgetData.subType === DashboardModuleLayoutWidgetSubType.REQUEST
    }

    get colorWidget(): string {
        return this.widgetData?.color ?? ''
    }

    get labelWidget(): string {
        return this.widgetData.label
    }

    async removeWidget(): Promise<void> {
        await store.dispatch('dashboard/removeWidgetAndSetVisible', this.widgetData)
    }

    async onKeyUpSearch(): Promise<void> {
        await this.getPatient()
    }

    async getPatient(): Promise<void> {
        for (let regex of this.regex) {
            const regexObj = new RegExp(`^(?:${regex.regex})$`)
            const searchTrim = this.state.search.trim()
            if (regexObj.test(searchTrim)) {
                if (regex.identifierType.idtScope === IDENTIFIER_SCOPES.PERSON) {
                    this.loadPatient(searchTrim)
                    break
                } else if (regex.identifierType.idtScope === IDENTIFIER_SCOPES.CENTER_PATIENT) {
                    this.loadPatient(searchTrim)
                    break
                }
            } else {
                if (this.state.search) {
                    this.$_showErrorModal(this.$tc('dashboard.errorMessages.invalidPatientId'))
                }
                break
            }
        }
    }

    async loadPatient(id: string) {
        const response: StrictNullable<IResponseAgGrid<PatientSearchResponse>> = await PromiseUtils.toCallSecure(patientService.getPatients({
            id,
            identifierType: PATIENT_IDENTIFIER_CODES.NIF
        }))
        if (response) {
            if (response.content.length > 1) {
                this.modalRepeatedPatients.show(response.content, id)
            } else if (response.content.length === 1) {
                this.showPatient(response.content[0])
            } else {
                this.$_showErrorModal(this.$tc('dashboard.errorMessages.noPatientFound', 1, { identifier: 'NIF' }))
            }
        }
    }

    showPatient(patient: PatientSearchResponse) {
        const name = this.isCaseSubtype ? DashboardModuleLayoutWidgetWidgetLink.NEW_CASE : DashboardModuleLayoutWidgetWidgetLink.NEW_REQUEST
        const params = this.isCaseSubtype ? Object.assign({ patId: `${patient.patId}` }) : Object.assign({ patientId: `${patient.patId}` })
        this.$router.push({
            name,
            params
        })
    }
}
